import { useStores } from "mobx-stores/_root-store";
import { useMemo } from "react";

export const useCheckOwner = (userId?: string | null) => {
  const {
    authentication: { profile },
  } = useStores();
  const isOwner = useMemo(() => {
    if (userId && profile?.userId === userId) {
      return true;
    }
    return false;
  }, [profile?.userId, userId]);
  return { isOwner };
};
